export const schemaRules = schema => [
  {
    validator: async ({ field }, value) => {
      await schema.validateSyncAt(field, { [field]: value })
    },
  },
]
